<template>
  <footer class="rcs-onboarding-nav">
    <Button
      v-if="showBack"
      :label="t('storeParameters.services.rcsServiceParameter.nav.back')"
      class="p-button-secondary p-button-outlined"
      type="button"
      :disabled="loading"
      @click="$emit('back')"
    />
    <div class="rcs-onboarding-nav__spacer" />
    <Button
      v-if="showSubmit"
      :label="t('storeParameters.services.rcsServiceParameter.nav.submit')"
      class="p-button-success"
      icon="fa-solid fa-rocket"
      type="button"
      :loading="loading"
      @click="$emit('submit')"
    />
    <Button
      v-else-if="showNext"
      :label="nextLabel || t('storeParameters.services.rcsServiceParameter.nav.next')"
      class="p-button-success"
      type="button"
      :disabled="!canGoNext || loading"
      @click="$emit('next')"
    />
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

export default defineComponent({
  name: 'RcsOnboardingNav',

  components: { Button },

  props: {
    showBack: { type: Boolean, default: false },
    showNext: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: false },
    canGoNext: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    nextLabel: { type: String, default: '' },
  },

  emits: ['back', 'next', 'submit'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
